import { render, staticRenderFns } from "./ValuesCard.vue?vue&type=template&id=e7322bfe&scoped=true&"
import script from "./ValuesCard.vue?vue&type=script&lang=ts&"
export * from "./ValuesCard.vue?vue&type=script&lang=ts&"
import style0 from "./ValuesCard.vue?vue&type=style&index=0&id=e7322bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7322bfe",
  null
  
)

export default component.exports